import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ExerciseModel } from '@generativ/much-smarter-models';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ExerciseService } from '../exercise.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-exercise-intro',
    templateUrl: './exercise-intro.component.html',
    styleUrls: ['./exercise-intro.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ExerciseIntroComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  exercise: ExerciseModel;
  exerciseId: number;
  videoUrl: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private exerciseService: ExerciseService,
              private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    this.subscriptions.add(this.route.data.subscribe(() => {

      this.subscriptions.add(this.route.params.subscribe((params: Params) => {
        this.exerciseId = +params['exerciseId'];
        this.subscriptions.add(this.exerciseService.getExerciseById(this.exerciseId).subscribe(
          exerciseModel => {
            this.exercise = exerciseModel;

            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.exercise.videoLink);
          }
        ));
      }));
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  startExercise(exerciseId: number) {
    this.subscriptions.add(this.exerciseService.startExercise(exerciseId).subscribe(() => {
      this.router.navigate(['../problem'], {relativeTo: this.route});
    }));
  }

  handleGetStarted(exerciseId) {
    if (this.exercise && this.exercise.lesson) {
      if (this.exercise.lesson.strategyLessonEnabled) {
        this.router.navigate(['../strategy/topic'], {relativeTo: this.route});
      } else {
        this.subscriptions.add(this.exerciseService.startExercise(exerciseId).subscribe(() => {
          this.router.navigate(['../problem'], {relativeTo: this.route});
        }));
      }
    }
  }
}
